import { Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Image from 'next/image';
import React from 'react';
import { useStyles } from '../style';

/**
 * @name NavList
 * @description Displays Nav list
 * @param {object} root0  - destructured object
 * @param {object} root0.nav - Header Data from Strapi
 * @param {boolean} root0.data - Header Data from Strapi
 * @param {Function} root0.index - Unique id of iterated  nav list
 * @param {boolean} root0.leftLink - For determining left or right navigation
 * @returns {JSX.Element} Next.js Image Element
 */
const NavList = ({ nav, index, data, leftLink }) => {
  const theme = useTheme();
  const style = useStyles(theme, leftLink, index);

  return (
    <Stack direction='row' alignItems='center' sx={style.topNavMain} key={index}>
      <Image
        width={16}
        height={16}
        src={`${data?.image?.data?.attributes?.url}`}
        alt={data?.image?.data?.attributes?.alternativeText}
      ></Image>
      <Typography variant='body2' component='p' sx={style.topLeftNavs}>
        {nav?.title}
      </Typography>
    </Stack>
  );
};

NavList.displayName = 'NavList';
export default NavList;
